export const PLATFORMS = {
    DESKTOP: 'DESK',
    MOBILE: 'PHON',
    TABLET: 'TBLT',
};
export const PLATFORMS_KEYS = Object.values(PLATFORMS);

export default PLATFORMS;
